import { render, staticRenderFns } from "./Capacity.vue?vue&type=template&id=661b0394&scoped=true&"
import script from "./Capacity.vue?vue&type=script&lang=js&"
export * from "./Capacity.vue?vue&type=script&lang=js&"
import style0 from "./Capacity.vue?vue&type=style&index=0&id=661b0394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661b0394",
  null
  
)

export default component.exports